import React from "react";
import "./football-app.css";

const Crest = ({ name, logo }) =>
  logo ? <img src={logo} alt="" loading="eager" /> : <span className="fa-crest" aria-hidden="true">{String(name || "?").slice(0, 2).toUpperCase()}</span>;

const Side = ({ name, logo, href, onNavigate }) => {
  const body = (
    <>
      <Crest name={name} logo={logo} />
      <b>{name}</b>
    </>
  );
  return href ? (
    <a className="fa-team" href={href} onClick={(e) => { if (onNavigate) { e.preventDefault(); onNavigate(href); } }}>{body}</a>
  ) : (
    <span className="fa-team">{body}</span>
  );
};

/** One entry per scorer: "L. Diaz 12', 47', 69'". Grouping is cosmetic; every minute comes from the event feed. */
export function groupScorers(goals = []) {
  const map = new Map();
  goals.forEach((g) => {
    const key = `${g.name}|${g.own ? "og" : ""}`;
    if (!map.has(key)) map.set(key, { name: g.name, own: g.own, minutes: [] });
    map.get(key).minutes.push(`${g.minute}${g.pen ? " pen" : ""}`);
  });
  return [...map.values()];
}
const scorerText = (g) => `${g.name} ${g.minutes.join(", ")}${g.own ? " (OG)" : ""}`;

/**
 * Compact premium match header. Every value is passed in from the page's real
 * fixture data; the component never defaults a score to 0-0.
 */
export default function MatchHeaderCompact({
  home, away, score, statusLabel, isLive, competition, kickoff, onBack, homeGoals = [], awayGoals = [], onNavigate,
}) {
  const hasScore = score && Number.isFinite(score.home) && Number.isFinite(score.away);
  return (
    <header className="fa-header">
      <div className="fa-wrap">
        <div className="fa-header-top">
          {onBack && <button type="button" className="fa-back" onClick={onBack} aria-label="Back to fixtures">←</button>}
          <div className="fa-header-meta">
            <strong>{competition || "Football"}</strong>
            {kickoff && <span>{kickoff}</span>}
          </div>
        </div>
        <div className="fa-scoreline">
          <Side {...home} onNavigate={onNavigate} />
          <div className="fa-score" aria-live={isLive ? "polite" : undefined}>
            <strong aria-label={hasScore ? `Score ${score.home} to ${score.away}` : "Not started"}>{hasScore ? `${score.home} – ${score.away}` : "vs"}</strong>
            <span className={`fa-chip ${isLive ? "live" : ""}`}>{isLive ? "● " : ""}{statusLabel}</span>
          </div>
          <Side {...away} onNavigate={onNavigate} />
        </div>
        {(homeGoals.length > 0 || awayGoals.length > 0) && (
          <div className="fa-goals-inline" aria-label="Goalscorers">
            <div>{groupScorers(homeGoals).map((g, i) => <div key={i}>⚽ <b>{scorerText(g)}</b></div>)}</div>
            <div>{groupScorers(awayGoals).map((g, i) => <div key={i}><b>{scorerText(g)}</b> ⚽</div>)}</div>
          </div>
        )}
      </div>
    </header>
  );
}
